 
const logout = () =>{
    return{
   type:'SSI_LOGOUT' 
}}

export default logout;